import { Grid } from "@mui/material";

import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import { ReactComponent as Article } from "assets/article.svg";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import Calender from "components/common/calender/Calender";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import { setPayloadData } from "../PlanAssignment.slice";
import "../index.scss";

const SelectedPlans = (props: any) => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const { isMobileScreen } = useContext(ThemeContext);
  const { isDateEditable } = props;
  const {
    payloadData: { plans },
    currentStep,
    flow
  } = useAppSelector((state) => state.PlanAssignment);

  const [isSeeAll, setIsSeeAll] = useState<boolean>(false);

  const addDueDate = (id: any, date: any) => {
    if (plans) {
      const data: any = plans?.map((plan: any) => {
        if (id === plan.id) return { ...plan, dueDate: date };
        return plan;
      });
      dispatch(setPayloadData({ plans: data }));
    }
  };

  const handleCollapse = () => {
    setIsSeeAll(!isSeeAll);
  };

  return (
    <div className="selected_plans">
      <div className={`selected_plans-titles ${flow?.[currentStep]}  ${isDateEditable ? "editable" : ""}`}>
        <Typography
          variant={"body2"}
          color={tokens.Text.General.PrimaryBody}
          className="selected_plans-titles-plan"
          showBold
        >
          Selected Plan
        </Typography>
        <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} showBold>
          Due date
        </Typography>
      </div>
      <div className={isDateEditable ? `selected_plans-static-list` : "selected_plans-list"}>
        {plans?.map((plan: any) => {
          return (
            <div
              key={plan?.id}
              className={`selected_plans-listItem ${flow?.[currentStep]} ${!isSeeAll ? " hidden-date" : ""} ${
                isDateEditable ? "editable" : ""
              }`}
            >
              <div className="selected_plans-planNameContainer">
                <Article />
                <Grid className="selected_plans-planName">
                  <Typography variant={"body2"} color={tokens.Icon.General.Primary}>
                    {plan?.name || plan?.title}
                  </Typography>
                </Grid>
              </div>
              <div>
                {isDateEditable ? (
                  <Calender
                    sx={{ marginLeft: isMobileScreen ? "0px" : "70px", width: isMobileScreen ? "100%" : "auto" }}
                    showLable={false}
                    buttonView={false}
                    defaultValue={plan?.dueDate || plan?.brandDeadlines?.[0]?.["deadline"]}
                    onChange={(val: any) => addDueDate(plan.id, val)}
                  />
                ) : (
                  <Typography variant={"body2"} color={tokens.Icon.General.Primary}>
                    {getUIFormatDate(plan?.dueDate || plan?.brandDeadlines?.[0]?.["deadline"]) || "-"}
                  </Typography>
                )}
              </div>
            </div>
          );
        })}
        {plans?.length > 2 && (
          <div className="date-collapse" onClick={handleCollapse}>
            <Typography variant="body2" color={tokens.Text.General.Secondary}>
              {!isSeeAll ? translate("common.seeAll") : translate("common.seeLess")}
            </Typography>
            <div className="date-collapse-icon">{!isSeeAll ? <ArrowDown /> : <ArrowUp />}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedPlans;
